"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.App = void 0;

var _style = _interopRequireDefault(require("styled-jsx/style"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIdleTimer = _interopRequireDefault(require("react-idle-timer"));

var _constants = require("../constants");

var _app = require("../store/actions/app");

var _app2 = require("../store/reducers/app");

var _conversation = require("../store/reducers/conversation");

var _app3 = require("../store/selectors/app");

var _conversation2 = require("../store/selectors/conversation");

var _conversation3 = require("../store/actions/conversation");

var _traffic = require("../store/actions/traffic");

var _styles = _interopRequireDefault(require("../styles"));

var _Conversation = _interopRequireDefault(require("./Conversation"));

var _Input = _interopRequireDefault(require("./Input"));

var _Loading = _interopRequireDefault(require("./Loading"));

var _StartOver = _interopRequireDefault(require("./StartOver"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var App =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(App, _PureComponent);

  function App(props) {
    var _this;

    _classCallCheck(this, App);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(App).call(this, props));
    _this.onChatElementScroll = _this.onChatElementScroll.bind(_assertThisInitialized(_this));
    _this.onUserIdle = _this.onUserIdle.bind(_assertThisInitialized(_this));

    _this.setIncomingProps(props, {});

    _this.chatElementRef = _react["default"].createRef();
    return _this;
  }

  _createClass(App, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getChatElementNode().addEventListener('scroll', this.onChatElementScroll);
      this.performScroll(true);
      this.props.conversationInitialize();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps
    /* prevState */
    ) {
      this.setIncomingProps(this.props, prevProps);
      var _this$props = this.props,
          appScrolled = _this$props.appScrolled,
          conversation = _this$props.conversation,
          conversationLastItem = _this$props.conversationLastItem,
          onNotification = _this$props.onNotification;

      if (prevProps.conversation.length !== conversation.length && conversationLastItem.type === _constants.CONVERSATION_TYPE_TEXT_HUMAN) {
        onNotification && onNotification(conversationLastItem.items && conversationLastItem.items[0]);
      }

      if (appScrolled) {
        this.performScroll();
      }
    }
  }, {
    key: "setIncomingProps",
    value: function setIncomingProps(props, prevProps) {
      if (props.env !== prevProps.env) props.appEnvSet(props.env);
      if (props.debug !== prevProps.debug) props.appDebugSet(props.debug);
      if (props.product !== prevProps.product) props.appProductSet(props.product);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.getChatElementNode().removeEventListener('scroll', this.onChatElementScroll);
    }
  }, {
    key: "getChatElementNode",
    value: function getChatElementNode() {
      return this.chatElementRef.current;
    }
  }, {
    key: "onChatElementScroll",
    value: function onChatElementScroll() {
      var chatElementNode = this.getChatElementNode();
      var offsetHeight = chatElementNode.offsetHeight,
          scrollHeight = chatElementNode.scrollHeight,
          scrollTop = chatElementNode.scrollTop;
      var difference = scrollHeight - (offsetHeight + scrollTop);
      this.props.appScrolledSet(difference < 1);
    }
  }, {
    key: "performScroll",
    value: function performScroll() {
      var instant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var chatElementNode = this.getChatElementNode();
      if (!chatElementNode) return;

      if (instant) {
        chatElementNode.scrollTop = chatElementNode.scrollHeight;
      } else if (chatElementNode.scrollTop + chatElementNode.offsetHeight < chatElementNode.scrollHeight) {
        var scrollInterval = setInterval(function () {
          var difference = chatElementNode.scrollHeight - (chatElementNode.scrollTop + chatElementNode.offsetHeight);
          var increment = Math.ceil(difference / 5);
          increment === 1 ? chatElementNode.scrollTop = chatElementNode.scrollHeight : chatElementNode.scrollTop = chatElementNode.scrollTop + increment;

          if (chatElementNode.scrollHeight - (chatElementNode.scrollTop + chatElementNode.offsetHeight) < 1) {
            chatElementNode.scrollTop = chatElementNode.scrollHeight;
            clearInterval(scrollInterval);
          }
        }, 20);
      }
    }
  }, {
    key: "onUserIdle",
    value: function onUserIdle() {
      this.props.trafficUserIdle();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          appContext = _this$props2.appContext,
          appTyping = _this$props2.appTyping;
      return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
        className: "jsx-3114548228 " + _style["default"].dynamic([["26011784", [_styles["default"].colors.grayLighter, _styles["default"].colors.lavender, _styles["default"].colors.bluePastel]]]) + " " + 'chatbot-container'
      }, _react["default"].createElement("div", {
        className: "jsx-3114548228 " + _style["default"].dynamic([["26011784", [_styles["default"].colors.grayLighter, _styles["default"].colors.lavender, _styles["default"].colors.bluePastel]]]) + " " + 'chatbot-row'
      }, _react["default"].createElement(_StartOver["default"], null)), _react["default"].createElement("div", {
        ref: this.chatElementRef,
        className: "jsx-3114548228 " + _style["default"].dynamic([["26011784", [_styles["default"].colors.grayLighter, _styles["default"].colors.lavender, _styles["default"].colors.bluePastel]]]) + " " + 'chatbot-row chatbot-content'
      }, _react["default"].createElement("div", {
        className: "jsx-3114548228 " + _style["default"].dynamic([["26011784", [_styles["default"].colors.grayLighter, _styles["default"].colors.lavender, _styles["default"].colors.bluePastel]]]) + " " + 'dialog-container'
      }, _react["default"].createElement(_Conversation["default"], null), appTyping && _react["default"].createElement("div", {
        className: "jsx-3114548228 " + _style["default"].dynamic([["26011784", [_styles["default"].colors.grayLighter, _styles["default"].colors.lavender, _styles["default"].colors.bluePastel]]]) + " " + ((0, _classnames["default"])('help--speech-bubble', 'help--speech-bubble-left', 'help--slide-in-up', appContext === _constants.CONTEXT_LIVE_ENGAGE ? 'help--speech-bubble-agent' : null) || "")
      }, _react["default"].createElement(_Loading["default"], null)))), _react["default"].createElement("div", {
        className: "jsx-3114548228 " + _style["default"].dynamic([["26011784", [_styles["default"].colors.grayLighter, _styles["default"].colors.lavender, _styles["default"].colors.bluePastel]]]) + " " + 'chatbot-row'
      }, _react["default"].createElement(_Input["default"], null)), _react["default"].createElement(_reactIdleTimer["default"], {
        element: typeof window !== 'undefined' && window && window.document ? window.document : null,
        timeout: 1000 * 60 * 5 // 5 minutes
        ,
        debounce: 250 // 250ms
        ,
        onIdle: this.onUserIdle
      })), _react["default"].createElement(_style["default"], {
        id: "26011784",
        dynamic: [_styles["default"].colors.grayLighter, _styles["default"].colors.lavender, _styles["default"].colors.bluePastel]
      }, ".help--speech-bubble{border-radius:1rem;box-sizing:border-box;display:inline-block;font-size:15px;line-height:1.25;max-width:350px;min-height:42px;padding:12px 18px;text-align:left;word-break:break-word;}.help--speech-bubble a{color:#444444;}.help--speech-bubble a:hover{color:#777777;}.help--speech-bubble-right{background-color:".concat(_styles["default"].colors.grayLighter, ";border-bottom-right-radius:0;color:#000;margin-left:45px;margin-right:0;}.help--speech-bubble-left{background-color:").concat(_styles["default"].colors.lavender, ";border-top-left-radius:0;color:#000;}.help--speech-bubble-agent{background-color:").concat(_styles["default"].colors.bluePastel, ";}.help--slide-in-up{-webkit-animation-duration:0.25s;animation-duration:0.25s;-webkit-animation-name:helpSlideInUp;animation-name:helpSlideInUp;-webkit-animation-iteration-count:1;animation-iteration-count:1;opacity:1;}@-webkit-keyframes helpSlideInUp{0%{opacity:0;-webkit-transform:translate(0,100%);-ms-transform:translate(0,100%);transform:translate(0,100%);}25%{opacity:0;-webkit-transform:translate(0,50%);-ms-transform:translate(0,50%);transform:translate(0,50%);}50%{opacity:0.15;-webkit-transform:translate(0,15%);-ms-transform:translate(0,15%);transform:translate(0,15%);}75%{opacity:0.5;-webkit-transform:translate(0,5%);-ms-transform:translate(0,5%);transform:translate(0,5%);}100%{opacity:1;-webkit-transform:translate(0,0);-ms-transform:translate(0,0);transform:translate(0,0);}}@keyframes helpSlideInUp{0%{opacity:0;-webkit-transform:translate(0,100%);-ms-transform:translate(0,100%);transform:translate(0,100%);}25%{opacity:0;-webkit-transform:translate(0,50%);-ms-transform:translate(0,50%);transform:translate(0,50%);}50%{opacity:0.15;-webkit-transform:translate(0,15%);-ms-transform:translate(0,15%);transform:translate(0,15%);}75%{opacity:0.5;-webkit-transform:translate(0,5%);-ms-transform:translate(0,5%);transform:translate(0,5%);}100%{opacity:1;-webkit-transform:translate(0,0);-ms-transform:translate(0,0);transform:translate(0,0);}}")), _react["default"].createElement(_style["default"], {
        id: "3114548228"
      }, ".chatbot-container.jsx-3114548228{background-color:#FAFAFA;bottom:0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;left:0;position:absolute;top:0;width:100%;}.chatbot-content.jsx-3114548228{-webkit-flex:1;-ms-flex:1;flex:1;overflow-y:scroll;}.dialog-container.jsx-3114548228{box-sizing:border-box;overflow:hidden;padding:18px;}"));
    }
  }]);

  return App;
}(_react.PureComponent);

exports.App = App;
App.propTypes = {
  appContext: _app2.appPropTypes.context,
  appDebugSet: _propTypes["default"].func.isRequired,
  appEnvSet: _propTypes["default"].func.isRequired,
  appScrolled: _app2.appPropTypes.scrolled,
  appScrolledSet: _propTypes["default"].func.isRequired,
  appTyping: _app2.appPropTypes.typing,
  conversation: _conversation.conversationPropTypes.base,
  conversationAppend: _propTypes["default"].func.isRequired,
  conversationInitialize: _propTypes["default"].func.isRequired,
  conversationLastItem: _propTypes["default"].object,
  trafficUserIdle: _propTypes["default"].func.isRequired,
  env: _propTypes["default"].string.isRequired,
  market: _propTypes["default"].string,
  onNotification: _propTypes["default"].func,
  product: _propTypes["default"].string,
  debug: _propTypes["default"].bool
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    appContext: (0, _app3.getAppContext)(state),
    appScrolled: (0, _app3.getAppScrolled)(state),
    appTyping: (0, _app3.getAppTyping)(state),
    conversation: (0, _conversation2.getConversation)(state),
    conversationLastItem: (0, _conversation2.getConversationLastItem)(state)
  };
};

var mapDispatchToProps = {
  appDebugSet: _app.appDebugSet,
  appEnvSet: _app.appEnvSet,
  appProductSet: _app.appProductSet,
  appScrolledSet: _app.appScrolledSet,
  conversationAppend: _conversation3.conversationAppend,
  conversationInitialize: _conversation3.conversationInitialize,
  trafficUserIdle: _traffic.trafficUserIdle
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(App);

exports["default"] = _default;